<div class="message mat-elevation-z4" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
  <ng-container *ngIf="message.forSuccess; else forError">
    <div class="message__label--success">
      <mat-icon>done</mat-icon>
    </div>
  </ng-container>
  <ng-template #forError>
    <div class="message__label--error">
      <mat-icon>clear</mat-icon>
    </div>
  </ng-template>
  <div class="message__text">
    {{ message.text }}
  </div>
  <mat-icon class="message__close" (click)="close()">clear</mat-icon>
</div>
